import { BroadsiderArticle, BroadsiderFooter, ScreenFrame, Megalogo, LoadingSpinner, PlayVideo } from '../components';
import BroadsiderThreeHud from '../components/BroadsiderHud/BroadsiderThreeHud';
import { useContentful } from '../hooks';
import { renderRichText } from '../utils';
import useIsMobile from '../hooks/useIsMobile';
import { useContext, useState } from 'react';
import { theme } from '../theme';
import { AppContext } from '../providers/AppContext';

const AvatarsTitle = () => {
  return (
    <div>
      <div className='article-title-secondary-text'>
        Avatars of the
      </div>
      <div className='article-title-main-text'>
        Solar Punk
      </div>
      <div className='article-title-main-text article-title-main-text-selected'>
        Revolution
      </div>
    </div>
  );
};

const IncubationTitle = () => {
  return (
    <div>
      <div className='article-title-main-text'>
        Avatar
      </div>
      <div className='article-title-main-text article-title-main-text-selected'>
        Incubation
      </div>
      <div className='article-title-secondary-text'>
        System
      </div>
    </div>
  );
};

const ActionTitle = () => {
  return (
    <div>
      <div className='article-title-secondary-text'>
        Welcome to
      </div>
      <div className='article-title-main-text article-title-main-text-selected'>
        The Next
      </div>
      <div className='article-title-main-text article-title-main-text-selected'>
        Internet
      </div>
    </div>
  );
};

const EXPANDED_MAP_SRC = '/assets/map_expanded.png';
export default function Broadside() {
  const { isLoading, articles } = useContentful();
  const isMobile = useIsMobile();
  const [videoSrc, setVideoSrc] = useState('/video.mp4');
  const {
    setShowVideo,
    showVideo,
    setMapSrc
  } = useContext(AppContext);

  const onClickFullscreen = () => {
    setShowVideo(true);
  };

  if (isLoading) {
    return (<div className='page'><LoadingSpinner /></div>);
  }

  const onExpandMap = () => {
    setMapSrc(EXPANDED_MAP_SRC);
  };

  return (
    <div className='page'>
      <div className='menu-placeholder'/>
      <ScreenFrame height={isMobile ? '90vh' : 'unset'}>
        <div className='video-holder'>
          <video id='bs-video' src={videoSrc} autoPlay loop muted={true} style={{ width: isMobile ? 'auto' : '100%', height: isMobile ? '100%' : 'auto' }} />
        </div>
        {!isMobile && <div style={{ position: 'absolute', bottom: '3rem', right: '3rem' }}><PlayVideo/></div>}
        <div style={{ position: 'absolute', top: '3rem', left: '3rem', bottom: '3rem', right: isMobile ? '3rem' : undefined, display: 'flex', flexDirection: isMobile ? 'row' : 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Megalogo />
        </div>
      </ScreenFrame>
      {!isMobile && <ScreenFrame height='90vh'>
        <BroadsiderThreeHud />
      </ScreenFrame>}
      <ScreenFrame>
        <BroadsiderArticle title={<ActionTitle />} imageUrl='/assets/article_action.jpg' articleImageUrl='/assets/action.gif' logoUrl='/assets/metaverse.svg' logoBgColor={theme.baseYellow}>
          {renderRichText(articles['Action'])}
        </BroadsiderArticle>
      </ScreenFrame>
      <ScreenFrame>
        <BroadsiderArticle imageAction={onExpandMap} title={<AvatarsTitle />} logoBgColor='rgba(97, 211, 152, 1)' logoUrl='/assets/leaf.svg' preTitle='Make' imageUrl='/assets/article_avatars.jpg' articleImageUrl='/assets/map.jpg' headerLogoUrl='/assets/rainforest_logo.jpg'>
          {renderRichText(articles['Avatars'])}
        </BroadsiderArticle>
      </ScreenFrame>
      <ScreenFrame>
        <BroadsiderArticle title={<IncubationTitle />} logoUrl='/assets/traits.svg' articleImageUrl='/assets/weapons.gif' imageUrl='/assets/article_system.jpg'>
          {renderRichText(articles['System'])}
        </BroadsiderArticle>
      </ScreenFrame>
      <BroadsiderFooter/>
    </div>
  );
}
